import React from 'react';
import classes from "./SubscriptionPage.module.css";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Canvas } from "@react-three/fiber";
import { Stars } from "@react-three/drei";
import { motion, useAnimation } from "framer-motion";
import { useState } from 'react';
import { SendOtpAPI } from '../Api/api';
import { useEffect } from 'react';
import { v4 as uuidv4 } from "uuid";
import { toast } from 'react-toastify';

const SubscriptionPage = () => {
    const navigate = useNavigate();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [termsModal, setTermsModal] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
      const { user } = useSelector((state) => state?.userSlice);
  

    useEffect(() => {
        if (user?.token) {
            navigate("/home");
        }
    }, [user]);

    useEffect(() => {
        if (searchParams.get("ext_ref")) {
            setExtRef(searchParams.get("ext_ref"));
        } else {
            setSearchParams({ ext_ref: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }
            setLoading(true);

            let msisdnWithCountryCode = msisdn?.toString().trim().replace(/\D/g, '');

            if (msisdnWithCountryCode.startsWith('0')) {
                msisdnWithCountryCode = msisdnWithCountryCode.slice(1);
            }

            if (!msisdnWithCountryCode.startsWith('94')) {
                msisdnWithCountryCode = '94' + msisdnWithCountryCode;
            }

            const response = await SendOtpAPI(msisdnWithCountryCode);
            console.log(response, 'response');
            setLoading(false);
            navigate("/otp", {
                state: {
                    msisdn: msisdnWithCountryCode,
                    referenceNo: response?.data?.data?.referenceNo,
                    extRef: extRef
                }
            })

        } catch (error) {
            setLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
        }
    }
    return (
        <section className={classes.landing}>
            <motion.div
                className={classes.container}
                initial={{
                    backgroundImage: "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                }}
                animate={{
                    backgroundImage: [
                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #0a58b7)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #f5b342)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #8e44ad)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #602A9A)",
                    ],
                }}
                transition={{
                    duration: 6,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                }}
            >
                <div className={classes.stars}>
                    <Canvas>
                        <Stars
                            radius={50}
                            depth={50}
                            count={1000}
                            factor={4}
                            saturation={0}
                            fade
                            speed={2}
                        />
                    </Canvas>
                </div>
            </motion.div>
            <div className={classes.main}>
                <header className={classes.header}>
                    <nav className={classes.nav}>
                        <div className={classes.logo_container}
                        >
                            <img
                                src="./assets/images/logo-white.png"
                                alt="ai"
                                className={classes.logo}
                            />
                        </div>

                        <div className={classes.nav_sub_container}>
                            <button
                                type="button"
                                className={classes.sign_in_btn}
                                onClick={() => {
                                    navigate(`/login?ext_ref=${extRef}`)
                                }}
                            >
                                Login
                            </button>
                        </div>
                    </nav>
                </header>
                <div className={classes.product_description_container}>
                    <form className={classes.form} onSubmit={handleFormSubmission} >

                        <h1 className={classes.heading}>
                            <span className={classes.highlight}>UV Genie {" "}</span>
                            is your intelligent AI companion designed to answer queries, assist with tasks, and provide instant support — anytime, anywhere.
                        </h1>

                        <div className={classes.username_field_form}>
                            <div className={classes.country_code}>
                                <img src="/assets/images/sri-lanka.png" alt="flag" className={classes.flag} />
                                <p className={classes.country_code_number}>+94</p>
                            </div>
                            <input
                                id="msisdn"
                                name="msisdn"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                autoFocus placeholder={"Enter Your Number"} className={classes.input_field_username}
                                onChange={(e) => {
                                    setMsisdn(e.target.value)
                                }}
                                value={msisdn}
                            />
                        </div>

                        <div className={classes.packs}>

                            <button type='button' className={`${classes.pack_box} ${classes.shade_blue}`}
                            >
                                <span className={`${classes.pack_header} ${classes.shade_blue}`}>Prepaid subscription price point</span>
                                <p className={`${classes.pack_price_point} ${classes.active}`}>
                                    10 LKR{" "}/{" "}
                                    Day
                                </p>
                            </button>

                            <button type='button' className={`${classes.pack_box} ${classes.shade_green}`}

                            >
                                <span className={`${classes.pack_header} ${classes.shade_green}`}>Postpaid subscription price point</span>
                                <p className={`${classes.pack_price_point} ${classes.active}`}>
                                    300 LKR{" "}/{" "}
                                    Month
                                </p>
                            </button>

                        </div>

                        <div className={classes.check_box_container}>
                            <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                                className={classes.check_box} checked
                            >
                            </input>
                            <label for="terms" className={classes.check_box_label}>
                                By Subscribing, you agree to our{" "}<span className={classes.link} onClick={() => setTermsModal(true)}>terms & conditions</span>
                            </label>
                        </div>

                        <button type="submit"
                            disabled={loading}
                            className={classes.login_btn}>{
                                loading ? "Please Wait..." : "Subscribe"
                            }</button>

                    </form>
                </div>
            </div>
        </section>

    )
}

export default SubscriptionPage